var _defs, _circle, _circle2, _path, _line, _line2, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAquaSenseBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 250,
    x2: 250,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AquaSense_Big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#5472ea"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    opacity: 0.1,
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.47,142.92a170.87,170.87,0,1,0,265.06,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 117.47,
    y1: 142.92,
    x2: 382.53,
    y2: 142.92,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 151.07,
    y1: 421.63,
    x2: 348.93,
    y2: 421.63,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82,207.3c33.34,0,33.34,24,66.68,24s33.34-24,66.68-24,33.34,24,66.69,24,33.34-24,66.68-24,33.35,24,66.69,24",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.27,350.09a134.26,134.26,0,0,0,0-85.63c25.54,9.71,42.1,25.27,42.1,42.82S167.81,340.38,142.27,350.09Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.48,307.28c15-29.22,52.85-49.95,97.12-49.95s82.08,20.73,97.13,49.95c-15.05,29.21-52.85,49.94-97.13,49.94S178.52,336.49,163.48,307.28Zm150.89-10.52a10.52,10.52,0,1,0,10.51,10.52A10.52,10.52,0,0,0,314.37,296.76Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAquaSenseBig);
export default __webpack_public_path__ + "static/media/AquaSense_Big.15586111821cb39a71db1bc91c326039.svg";
export { ForwardRef as ReactComponent };